import { FormattedMessage } from 'react-intl';
import { useParams } from 'react-router-dom';
import isMobile from 'is-mobile';

import ErrorBoundary from '@app/components/ErrorBoundary';
import Link from '@app/components/Link';
import PageTitle from '@app/components/PageTitle';

import AuthCheck from '../../../components/AuthCheck';
import {
  Skeleton,
  SubHeader,
  SubHeaderMenu,
  SubHeaderTitle,
} from '../../../components/Skeleton/Skeleton';
import messages from '../AccountLayout.messages';
import ProductDownloadsMobile from './ProductDownloadsMobile';

const ProductDownloadLayout = ({
  children,
}: {
  children?: React.ReactNode;
}) => {
  const { language } = useParams<{ language: string }>();

  const isMobileDevice = isMobile();

  return (
    <AuthCheck>
      <Skeleton>
        <ErrorBoundary>
          <PageTitle>{messages.title}</PageTitle>

          <SubHeader>
            <SubHeaderTitle>
              <a href={`/${language}/account/`}>
                <FormattedMessage {...messages.title} />
              </a>
            </SubHeaderTitle>

            <SubHeaderMenu>
              <a href={`/${language}/my-account/account-settings/`}>
                <FormattedMessage {...messages.accountSettings} />
              </a>
              <Link to="/:language/account/orders/">
                <FormattedMessage {...messages.orderHistory} />
              </Link>
              <a
                href={`/${language}/my-account/my-products-serials-downloads/`}
              >
                <FormattedMessage {...messages.productsSerialsAndDownloads} />
              </a>
              <a href={`/${language}/support/downloads/`}>
                <FormattedMessage {...messages.updatesAndDrivers} />
              </a>
              <Link to="/:language/account/subscription/">
                <FormattedMessage {...messages.subscription} />
              </Link>
              <a href={`/${language}/my-account/license-transfer/`}>
                <FormattedMessage {...messages.licenseTransfer} />
              </a>
            </SubHeaderMenu>
          </SubHeader>
          <div className="ni-tailwind-namespace">
            <div
              className="justify-center container content-start grow auto-rows-min mt-6 mb-12 xl:mb-18
                grid-cols-4 webex-grid lg:grid-cols-8 xl:grid-cols-12"
            >
              {isMobileDevice ? <ProductDownloadsMobile /> : children}
            </div>
          </div>
        </ErrorBoundary>
      </Skeleton>
    </AuthCheck>
  );
};

export default ProductDownloadLayout;
